<template>
  <PDivider :label="campo.label" />
</template>

<script setup lang="ts">
import { PDivider } from "@f360-dev/f360-prisma";
import { TIntegracaoCampoModel } from "../../@types/IntegracaoCampoModel";

defineProps<{
  campo: TIntegracaoCampoModel;
}>();
</script>
